import { appShare } from '@/common/utilities/appShare.js';
import { mapGetters } from 'vuex';
import DppButtonPresentational from './dpp-button/dpp-button.presentational.vue';
import { getCookie } from '../../../common/utilities/nojq/_cookie.js';

export default {
    name: 'propertyButton',
    inject: ['$eventBus'],
    props: {
        options: {
            type: Object,
            default: function () {
                return null;
            },
        },
    },
    components: {
        DppButtonPresentational,
    },
    computed: {
        ...mapGetters('glb', ['glb', 'favoriteListings', 'getPhoneNumber', 'getSplit', 'getSavedHomesCount']),
        ...mapGetters('dpp', ['dpp', 'getPhotos']),
        isFavorite() {
            return this.favoriteListings.indexOf(this.dpp.propertyId) !== -1;
        },
        hasOJOAgent() {
            return this.glb.agent.id && !this.glb.rentals;
        },
    },
    mounted() {
        if (this.isMobileWebViewMode()) {
            appShare.registerAppShareHandlers(this.dpp.propertyId);
        }
        this.$eventBus.$on('property-share', this.sendEmail);
        this.$eventBus.$on('eventbus-action-save-home', this.favoriteAction);
    },
    methods: {
        isMobileWebViewMode() {
            return this.glb.isMobile && appShare.isWebViewMode();
        },
        popPhotoView() {
            this.$eventBus.$emit('property-pop-photo', { cateIndex: 0, photoIndex: 0, single: !this.glb.isPhone });
        },
        popMapView() {
            this.$eventBus.$emit('property-pop-map', { popMapTypeId: 0, popStreetView: false });
        },
        popContactUs() {
            this.$eventBus.$emit('dialog-open-contactus', { enquiryType: 5 });
        },
        favoriteAction() {
            this.$eventBus.$emit('property-save-favorite', this.$options.name);
            if (this.glb.user.id && this.dpp.isPrOnly && !this.isFavorite) {
                this.$eventBus.$emit('dialog-center', { name: 'favoritePR', trigger: 'favoritePR', opt: { name: this.$options.name } });
            }
        },
        sendEmail() {
            var dppURL = this.glb.appUrl + this.dpp.path;
            const propertyId = this.dpp.propertyId;
            var smsChar = this.glb.OS === 'iOS' ? '%26' : '%3F';
            var sms = `utm_campaign%3Ddppsharing${smsChar}utm_medium%3Dsms${smsChar}utm_source%3Ddpp`;
            if (this.glb.user.id) {
                sms += `${smsChar}utm_term%3D${this.glb.user.id}`;
            } else {
                var anonymousId = getCookie('ajs_anonymous_id');
                if (anonymousId) {
                    sms += `${smsChar}utm_term%3D${anonymousId.replace(/"/g, '')}`;
                }
            }
            if (this.glb.user.role) {
                if (['COBROKER_AGENT', 'AGENT'].includes(this.glb.user.role)) {
                    sms += `${smsChar}utm_content%3D${this.glb.user.role}`;
                }
            }
            if (this.glb.influenceAgentId) {
                sms += `${smsChar}agentid%3D${this.glb.influenceAgentId}`;
            }

            // API is fairly new, check if it is supported
            if (this.glb.isMobile && navigator.share) {
                sms = sms.replace(/%3F/g, '%26');
                sms = `${dppURL}%3F${sms}`;
                navigator
                    .share({
                        title: this.molang('dpp.mvtEmail.shareHome'),
                        text: this.molang('dpp.mvtEmail.checkoutHome'),
                        url: unescape(sms),
                    })
                    .then(function () {
                        console.log('Successfully Shared');
                    })
                    .catch(function (e) {
                        console.log(e.message);
                    });
            } else {
                var emailOpt = {
                    propertyId,
                    listingId: this.dpp.listingId,
                    listingUrl: this.glb.appUrl + this.dpp.path,
                    staticMapUrl: this.dpp.mapUrls.length > 2 ? this.dpp.mapUrls[2].src : '',
                    propertyData: this.dpp,
                    showComment: false,
                    comment: 'I am interested in ' + this.dpp.geo.formatAddress + '.',
                    sms: `${this.glb.geo.formatAddress} ${dppURL}%3F${sms}`,
                    dialogTitle: this.molang('dpp.mvtEmail.shareHome'),
                };
                if (this.isMobileWebViewMode()) {
                    // through native share
                    appShare.sentNativeEventToAPP(this.glb.OS, 'shareDPP', { dppURL, propertyId });
                } else {
                    // through email
                    this.$eventBus.$emit('dialog-center', { name: 'mvtSendEmail', trigger: this.$options.name, opt: emailOpt });
                }
            }
        },
        openHotlead() {
            this.$eventBus.$emit('dialog-center', {
                name: 'mvtHotleadForm',
                trigger: this.$options.name,
                opt: {
                    hotleadType: 'GoSeeThisHomeHotleadInResponsiveDPP',
                    propertyId: this.dpp.propertyId,
                    propertyData: this.dpp,
                },
            });
        },
    },
};
